// 首页部分
import request from "@/utils/request";

// 发放统计-图表
export function findByCount(data) {
  return request({
    url: "/merchant/merchantStatistics/findByCount",
    method: "post",
    data
  });
}

// 发放统计-金额
export function selectDistributionStatistics(data) {
  return request({
    url: "/merchant/merchantStatistics/selectDistributionStatistics",
    method: "post",
    data
  });
}

// 签约概况
export function findByNoSignCount(data) {
  return request({
    url: "/merchant/merchantStatistics/findByNoSignCount",
    method: "post",
    data
  });
}

// 公告列表
export function publicAdministration(data) {
  return request({
    url: "/merchant/merchantStatistics/publicAdministration",
    method: "post",
    data
  });
}

// 首页-商户发放视图
export function postHomeView(data) {
  return request({
    url: "/merchant/merchantStatistics/home/pay/view",
    method: "post",
    data
  });
}

//首页-下载签约模板
export function getTemplate(params) {
  return request({
    url: "/merchant/staff/getTemplate",
    method: "get",
    params,
    exportFiles: true
  });
}
